import { RouteRecordRaw } from "vue-router";
import { AuthGuardService } from "@/_guard/AuthGuardService";


import accountLayout from "@/modules/account/views/viewAccountIndex.vue";
import account from "@/modules/account/views/viewAccount.vue";

const auth = new AuthGuardService();

export const AccountRoutes: RouteRecordRaw[] = [
  {
    path: '/account',
    name: 'viewAccountIndex',
    meta: {title: 'Manage Account'},
    component: accountLayout,
    beforeEnter: auth.guard,
    children: [
      {
        path: '',
        name: 'viewAccount',
        meta: {title: 'Account'},
        component: account
      },
    ]
    },
];